









































import { defineComponent, inject, ref } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import Fa6SolidCaretDown from '~icons/fa6-solid/caret-down'
import Fa6SolidCaretUp from '~icons/fa6-solid/caret-up'
import { useI18n } from '~/composables/i18n'
import { MappedProduct } from '~/types/product/productTypes'
import { usePriceBrick } from '~/composables/price-brick/usePriceBrick'

export default defineComponent({
  components: { Fa6SolidCaretDown, Fa6SolidCaretUp },
  setup() {
    const { t } = useI18n()
    const { getCustomFormulationPath } = usePriceBrick()

    const currentProduct = ref(inject('currentProduct', {}) as MappedProduct)
    const conjugates = ref(currentProduct.value.attributes?.conjugates ?? {})

    const isCaretDown = ref(true)
    const isParentProduct = ref(conjugates.value.isParent)
    const isCfProduct = ref(conjugates.value.isCarrierFree)
    const isChimericChild = ref(currentProduct.value.attributes?.isChimericChild)

    const displayCondition = ref(
      isParentProduct.value || isCfProduct.value || conjugates.value.isChild || isChimericChild.value
    )
    const childrenDisplayCondition = ref(
      ((isParentProduct.value && !isEmpty(conjugates.value.children)) ||
        (!isParentProduct.value && !isEmpty(conjugates.value.siblings))) &&
        !isChimericChild.value
    )

    const customFormulationPath = getCustomFormulationPath(currentProduct.value.key, currentProduct.value.name)

    const caretClick = () => {
      isCaretDown.value = !isCaretDown.value
    }

    return {
      t,
      isEmpty,
      conjugates,
      displayCondition,
      isParentProduct,
      isCfProduct,
      customFormulationPath,
      isCaretDown,
      caretClick,
      childrenDisplayCondition,
    }
  },
})
